<template>
    <w-divider class="my6"></w-divider>

    <JumlahKutipanSehingaHariIni />

    <w-divider class="my6"></w-divider>

    <PerbangdinganKutipanBulan />

    <PetaKutipanHasilMengikutDaerah />

    <w-divider class="my6"></w-divider>

    <w-flex class="grow justify-space-betweenx basis-zero">
        <w-card class="mb3 mr3">
            <div>
                <w-flex class="justify-space-between align-start">
                    <div>
                        <div class="dashboard-title">
                            Ringkasan Kutipan Pejabat Tanah
                        </div>
                        <div class="dashboard-subtitle mt1 mb3">
                            Sehingga Hari Ini
                        </div>
                    </div>
                    <w-button bg-color="primary" @click="handleSwitchTab(2)">
                        Lanjut
                        <i class="fal fa-angle-double-right ml2"></i>
                    </w-button>
                </w-flex>
                <div v-if="loading">
                    <w-spinner fade></w-spinner>
                </div>
                <fusioncharts
                    v-else
                    :type="chart2.type"
                    :width="chart2.width"
                    :height="chart2.height"
                    :dataformat="chart2.dataFormat"
                    :dataSource="chart2.dataSource"
                >
                </fusioncharts>
            </div>
        </w-card>

        <w-card class="mb3 mr3">
            <w-flex class="justify-space-between align-start">
                <div>
                    <div class="dashboard-title">
                        Ringkasan Kutipan Pejabat Daerah
                    </div>
                    <div class="dashboard-subtitle mt1 mb3">
                        Sehingga Hari Ini
                    </div>
                </div>
                <w-button bg-color="primary" @click="handleSwitchTab(3)">
                    Lanjut
                    <i class="fal fa-angle-double-right ml2"></i>
                </w-button>
            </w-flex>
            <div v-if="loading">
                <w-spinner fade></w-spinner>
            </div>
            <fusioncharts
                v-else
                :type="chart3.type"
                :width="chart3.width"
                :height="chart3.height"
                :dataformat="chart3.dataFormat"
                :dataSource="chart3.dataSource"
            >
            </fusioncharts>
        </w-card>
    </w-flex>

    <w-flex class="grow justify-space-betweenx basis-zero">
        <w-card class="mb3 mr3">
            <w-flex class="justify-space-between align-start">
                <div>
                    <div class="dashboard-title">
                        Ringkasan Kutipan Jabatan Perhutanan
                    </div>
                    <div class="dashboard-subtitle mt1 mb3">
                        Sehingga Hari Ini
                    </div>
                </div>
                <w-button bg-color="primary" @click="handleSwitchTab(4)">
                    Lanjut
                    <i class="fal fa-angle-double-right ml2"></i>
                </w-button>
            </w-flex>
            <div v-if="loading">
                <w-spinner fade></w-spinner>
            </div>
            <fusioncharts
                v-else
                :type="chart4.type"
                :width="chart4.width"
                :height="chart4.height"
                :dataformat="chart4.dataFormat"
                :dataSource="chart4.dataSource"
            >
            </fusioncharts>
        </w-card>

        <w-card class="mb3 mr3">
            <w-flex class="justify-space-between align-start">
                <div>
                    <div class="dashboard-title">
                        Ringkasan Kutipan Pelbagai Jabatan
                    </div>
                    <div class="dashboard-subtitle mt1 mb3">
                        Sehingga Hari Ini
                    </div>
                </div>
                <w-button bg-color="primary" @click="handleSwitchTab(5)">
                    Lanjut
                    <i class="fal fa-angle-double-right ml2"></i>
                </w-button>
            </w-flex>

            <div v-if="loading">
                <w-spinner fade></w-spinner>
            </div>
            <fusioncharts
                v-else
                :type="chart5.type"
                :width="chart5.width"
                :height="chart5.height"
                :dataformat="chart5.dataFormat"
                :dataSource="chart5.dataSource"
            >
            </fusioncharts>
        </w-card>
    </w-flex>
</template>
<script>
import PerbangdinganKutipanBulan from "../cart-EIS/PerbangdinganKutipanBulan";
import PetaKutipanHasilMengikutDaerah from "../cart-EIS/PetaKutipanHasilMengikutDaerah";
import JumlahKutipanSehingaHariIni from "../cart-EIS/JumlahKutipanSehingaHariIni";
import JumlahKutipanWidget from "../cart-EIS/JumlahKutipanWidget";

export default {
    components: {
        JumlahKutipanWidget,
        JumlahKutipanSehingaHariIni,
        PetaKutipanHasilMengikutDaerah,
        PerbangdinganKutipanBulan,
    },
    data(){
        return {
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            loading: true,
            chart2: {
                type: "column2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        showvalues: "1",
                        xaxisname: "Jenis Kutipan Hasil",
                        yaxisname: "Jumlah Kutipan Hasil",
                        numberprefix: "RM",
                        theme: "fusion",
                    },
                    data: [],
                },
            },
            chart3: {
                type: "column2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        showvalues: "1",
                        xaxisname: "Jenis Kutipan Hasil",
                        yaxisname: "Jumlah Kutipan Hasil",
                        numberprefix: "RM",
                        theme: "fusion",
                    },
                    data: [],
                },
            },
            chart4: {
                type: "column2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        showvalues: "1",
                        xaxisname: "Jenis Kutipan Hasil",
                        yaxisname: "Jumlah Kutipan Hasil",
                        numberprefix: "RM",
                        theme: "fusion",
                    },
                    data: [],
                },
            },
            chart5: {
                type: "column2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        showvalues: "1",
                        xaxisname: "Jenis Kutipan Hasil",
                        yaxisname: "Jumlah Kutipan Hasil",
                        numberprefix: "RM",
                        theme: "fusion",
                    },
                    data: [],
                },
            },
        }
    },
    methods: {
        async fetchData(){
            this.loading = true;
            await axios
                .get(`${this.apiBaseUrl}/dashboard/bar-kutipan-mengikut-jabatan-dan-jenis`)
                .then((resp) => {
                    const {tanah, daerah, hutan, pelbagai} = resp.data
                    this.chart2.dataSource.data = tanah
                    this.chart3.dataSource.data = daerah
                    this.chart4.dataSource.data = hutan
                    this.chart5.dataSource.data = pelbagai
                })
                .catch((err) => {
                    console.error(err);
                });
                
            this.loading = false
        }
    },
    mounted() {
        this.fetchData()
    }
}
</script>
